import { render, staticRenderFns } from "./FormularioProyectos.vue?vue&type=template&id=3eaeb28a&"
import script from "./FormularioProyectos.vue?vue&type=script&lang=js&"
export * from "./FormularioProyectos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports